<ng-container [formGroup]="form">
	<div formArrayName="movers" class='movers' [ngClass]="'view-'+viewMode" [class.has-verified]="hasVerifiedMovers">
		<ng-container *ngFor="let moverCtrl of movers.controls; let i = index">
			<div class='mover mover-element' *ngIf="viewMode === 'full' || displayedIndices.includes(i)"
				[formGroupName]="i"
				(click)="onCardClick($event, checkbox)"
				[ngClass]="{
					'selected': moverCtrl.get('checkbox')?.value,
					'disabled': !canSelect(moverCtrl),
					'verified': moverCtrl.get('_verified')?.value
				}">
				<div class='mover-logo'>
					<img [src]='moverCtrl.get("_logo")?.value ? "https://srl.ams3.cdn.digitaloceanspaces.com/logos/" + moverCtrl.get("_logo")?.value : "assets/images/no_logo.png"' />
				</div>
				<div class='mover-content'>
					<div class='score'>
						<div class='rating'>{{ moverCtrl.get('_rating')?.value }}</div>
						<div class='stars'>
							<img *ngFor="let star of getStars(moverCtrl.get('_rating')?.value)" [src]='star' class="star-icon">
						</div>
						<div class='amount'>{{ moverCtrl.get('_amount')?.value }} </div>
						<div class='verified-badge' *ngIf="moverCtrl.get('_verified')?.value">
							<mat-icon svgIcon='icons:verified'></mat-icon>
							<span i18n='@@moverVerifiedBadge'>Verified</span>
						</div>
					</div>
					<div class='name'>
						{{ moverCtrl.get('_name')?.value }}
					</div>
					<div class='city'>
						{{ moverCtrl.get('_city')?.value }}
					</div>
				</div>
				<label class='mover-actions'>
					<input #checkbox
					       type="checkbox"
					       [formControlName]="'checkbox'"
					       [disabled]="!canSelect(moverCtrl)" 
					       [tabIndex]="formService.verifyTabIndex(formGroupName)"
					       (change)="onCheckboxChange($event, moverCtrl)">
				</label>
			</div>
		</ng-container>
		<label class='more-movers mover-element' 
		       (click)='triggerModal()' 
		       (keydown.enter)='triggerModal()'
		       (keydown.space)='triggerModal()'
		       [tabIndex]='formService.verifyTabIndex(formGroupName)'
		       role='button'
		       aria-label='View other moving companies'
		       *ngIf='viewMode === "default" && movers.controls.length > 5'>
			<div class='more-movers-label' i18n>
				View other moving companies
			</div>
			<div class='more-movers-action' i18n>
				Adjust your selection
				<mat-icon svgIcon='icons:arrow-right'></mat-icon>
			</div>
		</label>
	</div>
</ng-container>